module.exports = __webpack_public_path__ + "static/media/bursts_19.a735b7ac.svg";